import { Outlet } from "react-router-dom";
import Navbar from "../component/navbar/Navbar";
import BottomNavbar from "../component/navbar/BottomNav";

export default function DashboardLayout() {
  return (
    <>
      <Navbar />
      <div className="pb-24 md:pb-0 pt-12 bg-gray-100">
        <Outlet />
      </div>
      <BottomNavbar />
    </>
  );
}
